import Vue from 'vue'

export default {
  setAll (state, payload) {
    Vue.set(state, 'all', [...payload])
  }
}
